var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Meta"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.51217 9.48203C2.51217 10.0166 2.6295 10.427 2.78286 10.6753C2.98393 11.0005 3.28384 11.1383 3.58958 11.1383C3.98393 11.1383 4.34469 11.0405 5.03992 10.0789C5.59688 9.30823 6.25316 8.22644 6.69474 7.54825L7.44255 6.39927C7.96203 5.60131 8.56329 4.71426 9.25268 4.113C9.81548 3.62225 10.4226 3.34961 11.0336 3.34961C12.0594 3.34961 13.0365 3.94406 13.7843 5.05896C14.6027 6.27999 15 7.81796 15 9.40511C15 10.3486 14.814 11.0419 14.4976 11.5896C14.1918 12.1193 13.5959 12.6485 12.5935 12.6485V11.1383C13.4518 11.1383 13.666 10.3496 13.666 9.44698C13.666 8.16071 13.3661 6.73325 12.7055 5.71329C12.2366 4.98982 11.629 4.54776 10.9606 4.54776C10.2376 4.54776 9.65579 5.09304 9.00195 6.06529C8.65433 6.58184 8.29747 7.21134 7.89679 7.92166L7.4557 8.70307C6.56962 10.2741 6.34518 10.632 5.90214 11.2225C5.12561 12.2566 4.46251 12.6485 3.58958 12.6485C2.55404 12.6485 1.89922 12.2001 1.49367 11.5244C1.16261 10.9738 1 10.2513 1 9.42799L2.51217 9.48203Z",
    fill: "#0081FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.19238 5.16558C2.88566 4.09693 3.88615 3.34961 5.03367 3.34961C5.69823 3.34961 6.35889 3.5463 7.04876 4.10959C7.80339 4.72546 8.60767 5.73958 9.61108 7.41095L9.97086 8.01076C10.8394 9.45769 11.3336 10.2021 11.6228 10.5531C11.9947 11.0039 12.2552 11.1383 12.5936 11.1383C13.4519 11.1383 13.6661 10.3496 13.6661 9.44698L15.0001 9.40511C15.0001 10.3486 14.8141 11.0419 14.4976 11.5896C14.1919 12.1193 13.596 12.6485 12.5936 12.6485C11.9704 12.6485 11.4183 12.5132 10.8078 11.9372C10.3384 11.4952 9.78975 10.7099 9.36765 10.0039L8.11205 7.90657C7.48206 6.85399 6.90417 6.06918 6.5697 5.71378C6.20991 5.3316 5.7474 4.87006 5.00933 4.87006C4.41195 4.87006 3.90465 5.28924 3.48011 5.93043L2.19238 5.16558Z",
    fill: "url(#paint0_linear_1489_5160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.00925 4.87006C4.41188 4.87006 3.90458 5.28924 3.48004 5.93043C2.87975 6.83646 2.51217 8.18603 2.51217 9.48203C2.51217 10.0166 2.6295 10.427 2.78286 10.6753L1.49367 11.5244C1.16261 10.9738 1 10.2513 1 9.42799C1 7.93091 1.41091 6.37054 2.19231 5.16558C2.88559 4.09693 3.88608 3.34961 5.03359 3.34961L5.00925 4.87006Z",
    fill: "url(#paint1_linear_1489_5160)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1489_5160",
    x1: 3.96989,
    y1: 9.04581,
    x2: 13.6096,
    y2: 9.53267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1489_5160",
    x1: 3.19085,
    y1: 10.1169,
    x2: 3.19085,
    y2: 6.56285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/Meta.3227b9b61df627b682107a1054788f75.svg";
export { ForwardRef as ReactComponent };